export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "ccsonAgent.worker.bundle.worker.js");
}
